import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const OfflineBanner = () => {
  const { t } = useTranslation();
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="bg-amber-500/90 px-4 py-2 text-center text-sm font-medium text-zinc-950">
      ⚠ {t('common.offlineBanner')}
    </div>
  );
};

export default OfflineBanner;
